// Narrow adapter for the imported Trucision CAPA machine.
export type UserRole =
  "App Admin" | "Lab Manager" | "Technician" | "Viewer" | "Supervisor";
export type WorkActor = { name: string; role: UserRole; system?: boolean };
export type GuardCheck = { ok: true } | { ok: false; reason: string };
export type WorkStatus = "open" | "in_progress" | "verifying" | "closed";
export const APPROVER_ROLES: UserRole[] = [
  "App Admin",
  "Lab Manager",
  "Supervisor",
];
